<template lang="pug">
  .component-policy
    .card
      .inner-content
        .row
          .column
            label Entity
            span {{item.sentinellable}} {{item.sentinellable_id}}
          .column
            label Content
            span {{item.content}}
          .column
            label Severity
            span {{severity}}
          .column
            label Date and Time
            span {{$dateFormat(item.timestamp, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
          .column
            router-link(:to="{name:item.sentinellable.toLowerCase(), params:{id:item.sentinellable_id}}", target= '_blank')
                i.fa.fa-angle-right.fa-3x.action

</template>

<script>

  import {mapState} from "vuex";

  export default {
    name: 'Sentinel',
    components: {},
    computed: {
      severity() {
        switch (this.item.severity) {
          case 0:
            return 'MAINTENANCE'
          case 1:
            return 'INFO'
          case 2:
            return 'MANAGEMENT'
          case '3':
            return 'DEFCON'

          default:
            return this.item.severity
        }
      },
      ...mapState({
        configuration: state => state.configuration,
      })
    },
    props: ['item', 'type']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Sentinel.vue?d71758d0